"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DownloadLink_1 = __importDefault(require("@Components/DownloadLink"));
const statements_1 = require("@App/api/routes/rightsholder/statements");
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Status_1 = __importDefault(require("@Components/Status"));
const RightsholderRateSheetDownloadLink = ({ rateSheetLink, status }) => {
    const fetchDownloadLink = (rate) => __awaiter(void 0, void 0, void 0, function* () {
        return (0, statements_1.getRateSheetDownloadUrl)(rate.rateSheetLink.substring(1)).then((response) => Promise.resolve(response.data.rateSheetURL));
    });
    return (react_1.default.createElement("div", { className: 'rate-sheet-download-link' },
        react_1.default.createElement(DownloadLink_1.default, { fetchLink: () => fetchDownloadLink(rateSheetLink), text: `Download${status === 'original' ? ' Original' : ''}` }),
        status === 'provisional' && react_1.default.createElement(Status_1.default, { status: 'provisional', circleFirst: true })));
};
exports.default = RightsholderRateSheetDownloadLink;
